import { Instagram, MessageCircle } from "lucide-react";
import { NAV_LINKS, SITE, LOGO_IMAGE } from "@/data/site";
import { buildWhatsAppUrl } from "@/lib/whatsapp";

const goTo = (id) => (e) => {
  e.preventDefault();
  document.getElementById(id)?.scrollIntoView({ behavior: "smooth", block: "start" });
};

export const Footer = () => {
  const year = new Date().getFullYear();
  return (
    <footer data-testid="site-footer" className="border-t border-border bg-[hsl(var(--brand-off-white))]">
      <div className="container-site grid gap-10 py-14 md:grid-cols-12">
        <div className="flex flex-col gap-4 md:col-span-5">
          <div className="flex items-center gap-3">
            <img
              src={LOGO_IMAGE}
              alt="Monograma RAMALIVE"
              className="h-12 w-12 rounded-full border border-border object-cover"
            />
            <div className="leading-none">
              <span className="block font-heading text-xl font-semibold tracking-[0.12em] text-foreground">RAMALIVE</span>
              <span className="block text-[10px] font-medium uppercase tracking-[0.3em] text-[hsl(var(--brand-taupe))]">
                Odontologia
              </span>
            </div>
          </div>
          <p className="max-w-sm text-sm leading-relaxed text-muted-foreground">
            Odontologia premium com conforto, discrição e atendimento personalizado. Seu sorriso, cuidado em
            cada detalhe.
          </p>
        </div>

        <nav className="flex flex-col gap-3 md:col-span-3" aria-label="Links do rodapé">
          <h3 className="text-xs font-semibold uppercase tracking-[0.22em] text-[hsl(var(--brand-taupe))]">Navegação</h3>
          {NAV_LINKS.map((l) => (
            <a
              key={l.id}
              href={`#${l.id}`}
              onClick={goTo(l.id)}
              data-testid={`footer-link-${l.id}`}
              className="w-fit rounded-md text-sm text-muted-foreground transition-colors duration-200 hover:text-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring"
            >
              {l.label}
            </a>
          ))}
        </nav>

        <div className="flex flex-col gap-3 md:col-span-4">
          <h3 className="text-xs font-semibold uppercase tracking-[0.22em] text-[hsl(var(--brand-taupe))]">Contato</h3>
          <a
            href={buildWhatsAppUrl()}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="footer-whatsapp-link"
            className="flex w-fit items-center gap-2 rounded-md text-sm text-muted-foreground transition-colors duration-200 hover:text-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring"
          >
            <MessageCircle className="h-4 w-4" />
            {SITE.whatsappDisplay}
          </a>
          <a
            href={SITE.instagram}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="footer-instagram-link"
            className="flex w-fit items-center gap-2 rounded-md text-sm text-muted-foreground transition-colors duration-200 hover:text-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring"
          >
            <Instagram className="h-4 w-4" />
            Instagram
          </a>
          <p className="text-sm text-muted-foreground">
            {SITE.address.line1}
            <br />
            {SITE.address.line2}
          </p>
          <p className="text-sm font-medium text-[hsl(var(--brand-taupe))]" data-testid="footer-epao-badge">
            Registro CRO-MG: {SITE.epao}
          </p>
        </div>
      </div>

      <div className="border-t border-border">
        <div className="container-site flex flex-col gap-2 py-6 text-xs text-muted-foreground sm:flex-row sm:items-center sm:justify-between">
          <p data-testid="footer-copyright">
            © {year} {SITE.name} · <span data-testid="footer-epao">{SITE.epao}</span>. Todos os direitos reservados.
          </p>
          <p>Solicitações de agendamento estão sujeitas à confirmação pela equipe.</p>
        </div>
      </div>
    </footer>
  );
};
